export default __webpack_public_path__ + "static/media/pragmatic.5b3da01b.svg";